import { Component, OnInit } from '@angular/core';
import { Part, PartAlias, PartAliasType } from 'app/core/model/entity-model';
import DataSource from 'devextreme/data/data_source';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, AuthService, GenesisUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-part-alias-dialog',
    templateUrl: './part-alias-dialog.component.html',
    styleUrls: ['./part-alias-dialog.component.scss'],
    standalone: false
})
export class PartAliasDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    part: Part;
    partAlias: PartAlias;
    vendorsDS: DataSource;
    types: PartAliasType;
    mode: string;
    quickBooksItems: any[] = [];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        const vendors = await this.uow.getVendors();
        this.quickBooksItems = await this.uow.purchaseOrderLineItems.whereActive();
        this.types = this.uow.lookups.partAliasTypes;
        this.vendorsDS = new DataSource({
            store: vendors,
            paginate: true,
        });


    }

    async save() {
        const result = await this.validate();
        if (!result) return;

        this.result.next({ success: true, value: this.partAlias });
    }

    close() {
        // if (this.mode === 'add') this.partAlias.entityAspect.setDetached();
        this.partAlias.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('aliasValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('aliasValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\r\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\r\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
